<template>
    <div>
        <PurchaseOrder
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.PURCHASE_ORDER].route
            "
        />
        <Letter
            ref="letterDetail"
            v-if="templateType === TEMPLATES.LIST[TEMPLATES.TYPE.LETTER].route"
        />
        <MedicalNote
            ref="medicalNoteDetail"
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.MEDICAL_NOTE].route
            "
        />
        <Invoice
            ref="invoiceDetail"
            v-if="templateType === TEMPLATES.LIST[TEMPLATES.TYPE.BUNDLE].route"
        />
        <Estimate
            ref="estimateDetail"
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.BUNDLE_ESTIMATE].route
            "
        />
        <WellnessPlan
            ref="wellnessPlanDetail"
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.WELLNESS_PLAN].route
            "
        />
        <Attachment
            v-if="
                templateType === TEMPLATES.LIST[TEMPLATES.TYPE.ATTACHMENT].route
            "
        />
        <ContentSnippet
            ref="snippetDetail"
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.CONTENT_SNIPPET].route
            "
        />
        <!-- ref for edit purpose, maybe use commit instead use $ref.parent.$ref.child.save() -->
        <Webform
            ref="webformDetail"
            v-if="
                templateType ===
                TEMPLATES.LIST[TEMPLATES.TYPE.WEBFORM_TEMPLATE].route
            "
            @setFormDirty="isDirty => (form_dirty = isDirty)"
        />
    </div>
</template>

<script>
import PurchaseOrder from "./purchase-order.vue";
import Letter from "./letter.vue";
import MedicalNote from "./soap.vue";
import Invoice from "./invoice.vue";
import Estimate from "./estimate.vue";
import WellnessPlan from "./wellness-plan.vue";
import TEMPLATES from "@/constants/templates";
import Attachment from "./attachment.vue";
import ContentSnippet from "./content-snippet.vue";
import Webform from "@/components/setting-webform/webform.vue";
import unsavePrompt from "@/mixins/unsave-prompt.js";

// more template will be added here

export default {
    mixins: [unsavePrompt],
    components: {
        PurchaseOrder,
        Letter,
        MedicalNote,
        Invoice,
        Attachment,
        Webform,
        ContentSnippet,
        Estimate,
        WellnessPlan
    },
    computed: {
        templateType() {
            /**
             * refer URL for template type, eg:-
             * /view/settings/template/:type/:id
             */
            return this.$route.params.type;
        }
    },
    data() {
        return {
            TEMPLATES,
            form_dirty: false
        };
    }
};
</script>
